import { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { useAuth } from "./AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const fragment = location.hash || window.location.hash;
    const match = fragment.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = match[1];
    (async () => {
      try {
        const res = await axios.post(
          `${API}/auth/session`,
          {},
          {
            headers: { "X-Session-ID": sessionId },
            withCredentials: true,
          }
        );
        setUser(res.data.user);
        // clear hash and go to admin
        window.history.replaceState({}, "", "/admin");
        navigate("/admin", { replace: true, state: { user: res.data.user } });
      } catch (err) {
        const msg = err?.response?.data?.detail || "Login mislukt";
        setError(msg);
      }
    })();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen bg-[#F7F5F0] grid place-items-center p-6">
      <div className="max-w-md text-center" data-testid="auth-callback">
        {error ? (
          <>
            <h1 className="heading-display text-3xl mb-4">Geen toegang</h1>
            <p className="text-ink mb-6">{error}</p>
            <a href="/login" className="btn-editorial btn-editorial-primary">Terug</a>
          </>
        ) : (
          <>
            <div className="w-10 h-10 rounded-full border-2 border-navy border-t-transparent animate-spin mx-auto mb-6" />
            <p className="text-ink">Inloggen…</p>
          </>
        )}
      </div>
    </div>
  );
}
